import React, { useMemo } from 'react';
import { useLocation } from 'react-router';
import { observer } from 'mobx-react-lite';
import Popover from '@/components/popover';
import DropDownMenu from '@/components/dropDownMenu';
import { useMenuList, useMoreList } from '@/hooks/header';
import cx from 'classnames';
import MenuItem from './MenuItem';
import cs from './index.module.scss';

const Menu: React.FC = () => {
  const { pathname } = useLocation();
  const menuList = useMenuList();

  const widthMin = 180;
  const widthMax = 300;

  const clacWidth = (index: number): number => {
    let charLen = 0;
    const info = menuList[index] || [];
    info['children']?.map((item: any) => {
      if (item.title.length > charLen) {
        charLen = item.title.length;
      }
    });

    let width = charLen * 10;
    width = Math.max(width, widthMin);
    width = Math.min(width, widthMax);

    return width || 232;
  };

  const moreList = useMoreList();
  const renderMoreList = useMemo(() => moreList.map((item, index) => <MenuItem key={index} {...item} />), [moreList]);

  return (
    <div className={cs.menuRow}>
      {/* {renderMoreList} */}
      <ul className={cx('header-ul','p-t')}>
        {menuList.map((item: any, index: number) => (
          <li key={index} className={cs.headerLi}>
            {item.children ? (
              <Popover placement="bottom-start" width={300} content={<DropDownMenu data={item.children} />}>
                <a
                  className={cx(
                    'flex_c',
                    cs.header_title,
                    pathname.includes(item.baseUrl) ? 'active' : '',
                    pathname.includes(item.baseUrl) ? cs.active : '',
                  )}
                >
                  <span className={cs.title}> {item.title} </span>
                  {item.icon ? <span className={cx(cs.icon, 'header_title')}>{item.icon}</span> : null}
                </a>
              </Popover>
            ) : (
              <a href={item.url} className={pathname.includes(item.baseUrl) ? 'active' : ''} onClick={item.onClick}>
                {item.title} {item.icon ? <span className={cs.icon}>{item.icon}</span> : null}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default observer(Menu);
